export function ResolvePermalinkUrl(_permalink, _windowOpen) {
  let result = '';

  if (_permalink) {
    result = `https://agrolabores.com/perfil/${_permalink}`
  }

  if (_windowOpen === true && result) {
    result = `window.open('${result}', '_blank')`
  }
  return result;
}
